.selectedFilterTagsContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.nonEmptyFilterTags {
  padding-bottom: 16px;
}

.productFilterDeselectAllFiltersContainer {
  cursor: pointer;
  color: var(--colors-text-main);
  border-bottom: 1px dashed var(--colors-text-main);
}
